export default __webpack_public_path__ + "static/media/activity.24e13b02.svg";